import React from 'react'
import './Preview.scss'
import { connect } from 'react-redux'
import until from '../../../../utils/utils'
import { TreeNode, LegoParser } from 'bxl-legocore'
import OutLine from '../../../../components/OutLine'
import * as components from 'lego-components'
import { withTranslation } from 'react-i18next'
const mapStateToProps = (state: any) => {
  return {
    tree: state.tree,
  }
}

export interface IPreviewProps {
  tree?: any
  t: (str: string) => string
}
const clickTo = () => {}
class Preview extends React.Component<IPreviewProps> {
  componentDidMount() {
    until.setPcCompatStyle()
  }
  render() {
    const { tree } = this.props
    const { root } = tree
    const { config } = root
    const content = LegoParser(tree)
    return (
      <div className="preview_container">
        <h2 className="preview-header">{this.props.t('preview')}</h2>
        <div className="preview_phone">
          <div className="preview_phone_header">
            <div id="actName" className="actName ng-binding">
              {config.title || this.props.t('venueTitle')}
            </div>
          </div>
          <div className="preview_content pageContent" style={{ backgroundColor: config.bgColor }}>
            <TreeNode
              {...content}
              components={components}
              OutLine={OutLine}
              clickTo={clickTo}
            ></TreeNode>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, null)(withTranslation()(Preview))
